import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Paragraph from '../Paragraph/Paragraph';
import FundAccountSelect from '../FundAccountSelect/FundAccountSelect';
import { HeadingSubtitle } from '../Heading';
import Back from '../Buttons/Back';
import themeColors from '../../assets/styles/themeColors';

const SelectFundingMethod = ({
  handleNext,
  handleBack,
  nextPath,
  onModalClose,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {handleBack && <Back onClick={handleBack} />}
      <HeadingSubtitle mb={12} color={themeColors.colorTextSecondary}>
        {t('fundAccount.normalTitle')}
      </HeadingSubtitle>
      <Paragraph mb={32} color={themeColors.colorTextXLLight}>
        {t('fundAccount.normalSubtitle')}
      </Paragraph>
      <FundAccountSelect
        handleNext={handleNext}
        nextPath={nextPath}
        onModalClose={onModalClose}
      />
    </>
  );
};

SelectFundingMethod.propTypes = {
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
  nextPath: PropTypes.string,
  onModalClose: PropTypes.func,
};

export default SelectFundingMethod;
